module.exports = __webpack_public_path__ + "static/img/11.dc14519.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/zh/11.png
// module id = pZUI
// module chunks = 0